import { css } from 'lit';

// these styles can be imported from any component
// for an example of how to use this, check /pages/about-about.ts
export const styles = css`
  @media(min-width: 1000px) {
    wa-card {
      max-width: 70vw;
    }
  }
  a {
    /* Every page imports this sheet because global CSS cannot cross a component's Shadow DOM. */
    border-radius: 999px;
    color: var(--app-color-link);
    padding: 0.25em 0.5em;
    text-underline-offset: 5px;
    transition: background-color 150ms ease, color 150ms ease;
  }

  a:visited {
    color: var(--app-color-link-visited);
  }

  a:hover {
    background-color: var(--app-link-hover-background);
  }

  a:visited:hover {
    background-color: var(--app-link-visited-hover-background);
  }

`;